import baseUrl from "../lib/url";
import API, { handleRequest } from "../lib/api";
import { getActiveClientId, getActiveRestaurantId, getActiveRestaurantSystemId } from "@/lib/idProvider";

export const getCallLogs = (restaurantId, params = {}) =>
  handleRequest(() => {
    const filteredParams = Object.entries(params || {}).reduce(
      (accumulator, [key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          accumulator[key] = value;
        }

        return accumulator;
      },
      {},
    );

    const query = new URLSearchParams(filteredParams).toString();
    const endpoint = query
      ? `utility/restaurants/${restaurantId}/call-logs?${query}`
      : `utility/restaurants/${restaurantId}/call-logs`;

    return API.get(endpoint);
  });

export const uploadImageToServer = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("directory", `restaurant/${getActiveRestaurantId()}/staff/image`);
  formData.append("client_id", getActiveClientId() || "1");
  formData.append("restaurant_system_id", getActiveRestaurantSystemId());
  formData.append("restaurant_id", getActiveRestaurantId());

  try {
    const response = await API.post(
      `utility/file-manager`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteFileApi = async (fileId) => {
  try {
    const data = await API.delete(`utility/file-manager/${fileId}`);
    return data.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getAlldays = async () => {
  try {
    const data = await API.get(`utility/days`);
    return data.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updatePin = async (data) =>
  handleRequest(() => API.post("update-pin", data));

export const updateNotification = async (data) =>
  handleRequest(() => API.post("update-notification-settings", data));
